import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CredentialsService } from '@app/core';

export interface OAuthAuthorizationScope {
  id: string;
  description: string;
}

export interface OAuthAuthorizationConsentResponse {
  status: 'consent_required';
  auth_token: string;
  client: {
    id: string | number;
    name: string;
    description?: string | null;
    icon_url?: string | null;
  };
  user: {
    name: string;
    email: string;
    phone: string;
  };
  scopes: OAuthAuthorizationScope[];
}

export interface OAuthAuthorizationRedirectResponse {
  status: 'redirect';
  redirect_url: string;
}

export type OAuthAuthorizationResponse = OAuthAuthorizationConsentResponse | OAuthAuthorizationRedirectResponse;

@Injectable({
  providedIn: 'root'
})
export class OAuthAuthorizationService {
  constructor(
    private httpClient: HttpClient,
    private credentialsService: CredentialsService
  ) {}

  create(parameters: Record<string, string>): Observable<OAuthAuthorizationResponse> {
    return this.httpClient.skipErrorHandler().get<OAuthAuthorizationResponse>('/oauth/authorize', {
      params: new HttpParams({ fromObject: parameters }),
      headers: this.credentialsService.authorizationHeader
    });
  }

  approve(authToken: string, scopes: string[]): Observable<{ redirect_url: string }> {
    return this.httpClient.skipErrorHandler().post<{ redirect_url: string }>('/oauth/authorize', { auth_token: authToken, scopes }, { headers: this.credentialsService.authorizationHeader });
  }

  deny(authToken: string): Observable<{ redirect_url: string }> {
    return this.httpClient.skipErrorHandler().delete<{ redirect_url: string }>('/oauth/authorize', {
      params: { auth_token: authToken },
      headers: this.credentialsService.authorizationHeader
    });
  }
}
